export function useCatalogGridView() {
  try {
    const config = localStorage.getItem('catalogGridViewConfig');
    return config ? JSON.parse(config).enabled === true : false;
  } catch (error) {
    return false;
  }
}

export function useCatalogSort() {
  try {
    const config = localStorage.getItem('catalogSortConfig');
    return config ? JSON.parse(config).enabled === true : false;
  } catch (error) {
    return false;
  }
}

export function getCatalogSortPreference() {
  try {
    return localStorage.getItem('catalogSortPreference') || 'az';
  } catch (error) {
    return 'az';
  }
}

export function setCatalogSortPreference(pref) {
  try {
    localStorage.setItem('catalogSortPreference', pref);
  } catch (error) {
    // ignore
  }
}
